<template>
    <div
        class="top-menu-container margin-bottom"
    >
        <ul
            :class="classes"
            class="menu padding-left"
            @mouseover="displayMegaMenu()"
            @mouseleave="hideMegaMenu()"
        >
            <li
                v-if="!options.IsAuthenticated"
                class="align-middle"
                @mouseenter="setMegaMenuPage(-1)"
            >
                <a
                    v-if="options.BecomeMemberLink"
                    :href="options.BecomeMemberLink.Url"
                    :data-clicklabel="options.BecomeMemberLink.Text"
                    :data-clickaction="'click-header ' + websiteType"
                    data-clickcategory="header"
                    class="button small"
                    v-html="options.BecomeMemberLink.Text"
                />
            </li>
            <li
                v-for="(element, i) in options.HeaderTopMenuElementModels"
                :key="i"
                class=""
                @mouseenter="setMegaMenuPage(i, element)"
            >
                <top-menu-element
                    :options="element.Link"
                    :active="i===megaMenuPage && isMegaMenuShown"
                    :website-type="websiteType"
                />
            </li>
        </ul>
    </div>
</template>
<script>
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';
import TopMenuElement from './TopMenuElement.vue';

export default {
    name: 'TopMenu',
    components: {
        TopMenuElement
    },
    mixins: [
        HeaderBaseMixinVue
    ],
    props: {
        options: {
            type: Object,
            default() {
                return {
                    ListLength: 0,
                    BecomeMemberLink: {
                        Url: '',
                        Text: ''
                    }
                };
            }
        },
        classes: {
            type: String,
            default() {
                return '';
            }
        }
    },
    computed: {
        choosenMegaMenu() {
            return this.$store.state.header.megaMenuPage;
        },
        megaMenuShown() {
            return this.$store.state.header.megaMenuPage;
        }
    },
    methods: {
        hideMegaMenu() {
            this.$store.commit('header/topMenuHideMegaMenu');
        },
        displayMegaMenu() {
            this.$store.commit('header/topMenuDisplayMegaMenu');
        },
        setMegaMenuPage(pageNumber, element) {
            if (pageNumber > -1 && element.MegaMenuCategories.length !== 0) {
                this.$store.commit('header/setMegaMenuPage', pageNumber);
            } else {
                this.$store.commit('header/setMegaMenuPage', -1);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';

.margin-bottom {
    margin-bottom: $header-gutter-bottom;
}

.padding-left {
    li {
        padding-left: $spacing-top-menu-items;

        &:first-child {
            padding-left: 0;
        }
    }
}

.top-menu-container {
    line-height: $menu-line-height;
}
</style>
